function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.583 4.314c0 1.163-.421 2.165-1.262 3.007-.842.841-1.844 1.262-3.007 1.262-1.193 0-2.21-.421-3.052-1.262C.421 6.479 0 5.477 0 4.314c0-1.193.421-2.21 1.262-3.052C2.104.421 3.121 0 4.314 0c1.163 0 2.165.421 3.007 1.262.841.842 1.262 1.859 1.262 3.052Zm11.107 7.528v3.259h.138c.49-.949 1.324-1.829 2.502-2.64 1.178-.81 2.669-1.216 4.475-1.216 3.733 0 6.142 1.086 7.229 3.259 1.086 2.172 1.629 4.865 1.629 8.078v13.035h-7.39V24.051c0-1.377-.168-2.769-.504-4.177-.337-1.408-1.454-2.111-3.351-2.111s-3.106.627-3.626 1.882c-.52 1.254-.78 2.662-.78 4.222v11.75h-7.39V11.842h7.068Zm-19.093 0h7.389v23.775H.597V11.842Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.5184 0 0 .5184 3.276 3)"
  }));
};
export default SvgSocialLinkedin;